import { get } from '@elementary/common-ui/utils/http';
import type { ProjectField } from './types';

export const fetchProjectFields = (
  envId: string,
  integrationId: string,
  projectId: string,
): Promise<{
  fields: Record<string, ProjectField[]>;
  project_key?: string;
  base_url?: string;
}> =>
  get(
    `${window.VITE_API_BASE_URL}/settings/${envId}/ticketing/${integrationId}/jira/projects/${projectId}/fields`,
  );

export const fetchJiraFieldAutocomplete = (
  envId: string,
  integrationId: string,
  autocompleteUrl: string,
  query: string = '',
  projectId?: string,
  issueType?: string,
): Promise<{
  suggestions: Array<{ value: string; label: string }>;
}> =>
  get(
    `${window.VITE_API_BASE_URL}/settings/${envId}/ticketing/integrations/${integrationId}/jira/fields/autocomplete`,
    {
      autocomplete_url: autocompleteUrl,
      query,
      ...(projectId && { project_id: projectId }),
      ...(issueType && { issue_type: issueType }),
    },
  );
